import CustomTooltip from "shared/components/CustomTooltip";
import { CustomizationColors, IconDispatcher, SwimlaneColors } from "shared/ui-basics";
import styled, { css } from "styled-components";


interface ColorPickerProps {
	variant: "swimlane" | "taxonomy";
	onSelect: ({ e, color }: { e: any; color: string }) => void;
	selectedColor: string;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({ variant, onSelect, selectedColor }) => {
	let colorData = [];
	switch (variant) {
		case "swimlane":
			colorData = Object.keys(SwimlaneColors).map((key) => ({
				color: key,
			}));
			break;
		case "taxonomy":
			colorData = Object.keys(CustomizationColors).map((key) => ({
				color: key,
				description: CustomizationColors[key].description,
			}));
			break;
		default:
			break;
	}

	return (
		<Container>
			{colorData?.map((data) => (
				<CustomTooltip key={data.color} text={data?.description} placement="bottom" disabled={!data?.description}>
					<ColorBubble color={data.color} onClick={(e) => onSelect({ e, color: data.color })}>
						<Check visible={selectedColor === data.color}>{IconDispatcher("CHECK")}</Check>
					</ColorBubble>
				</CustomTooltip>
			))}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

const ColorBubble = styled.div<{ color: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background-color: ${({ color }) => color};
	${({ color }) =>
		color === "#FFFFFF" &&
		css`
			border: 1px solid #d9d9d9;
		`};

	:hover {
		cursor: pointer;
	}
`;

const Check = styled.div<{ visible: boolean }>`
	visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
	path {
		fill: #fff;
	}
`;
